export enum UserRole {
  ClientsAll = 'ClientsAll',
  ClientsOwned = 'ClientsOwned'
}
